module.exports = __webpack_public_path__ + "img/linuxStep2.787dcce4.png";